export default __webpack_public_path__ + "static/media/Boots of the Cloudcleaver.16f099eb.jpg";